import { StandardEvents } from '@shopify/events';

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-xplrs-cart-link]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  await customElements.whenDefined('theme-drawer');
  drawer.open();
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ detail }) => {
    if (!detail?.items) return;
    const count = detail.items.reduce((total, item) => total + item.quantity, 0);
    document.querySelectorAll('[data-xplrs-cart-count]').forEach((node) => { node.textContent = String(count); });
    document.querySelectorAll('[data-xplrs-label-template]').forEach((node) => {
      node.setAttribute('aria-label', node.dataset.xplrsLabelTemplate.replace('__COUNT__', String(count)));
    });
  }).catch(() => {});
});
